import { render, staticRenderFns } from "./v-banner.vue?vue&type=template&id=2ad67011&scoped=true&"
import script from "./v-banner.vue?vue&type=script&lang=js&"
export * from "./v-banner.vue?vue&type=script&lang=js&"
import style0 from "./v-banner.vue?vue&type=style&index=0&id=2ad67011&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad67011",
  null
  
)

export default component.exports